<template>
  <div class="w-100">
    <div class="p-4 mb-5 pb-2 rounded-6 box-shadow-main bg-white border">
      <div
        class="d-flex justify-content-between align-items-start cursor-pointer"
        @click="toggleCollapse()">
        <div class="mr-md-4 mr-3">
          <img src="../../../../assets/img/icon/price-tag.png" width="40" />
        </div>
        <div class="w-100">
          <p
            class="mb-0 body-2-2 text-20 font-bold"
            :class="{ 'text-semi-light': disabled }">
            {{ getMerchant().cart_promo_code_title }}
          </p>
          <p
            class="mb-0 body-2-2 font-regular"
            :class="{ 'text-semi-light': disabled }">
            {{ getMerchant().cart_promo_code_subtitle }}
          </p>
          <p class="mb-0 body-2-2 font-semibold text-danger" v-if="disabled">
            Cannot apply promo code while claiming reward
          </p>
        </div>
        <div>
          <svg
            width="14"
            class="transform-90 mr-2"
            height="24"
            viewBox="0 0 12 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.165039 18.13L1.93504 19.9L11.835 10L1.93504 0.100006L0.165039 1.87001L8.29504 10L0.165039 18.13H0.165039Z"
              class="fill-primary" />
          </svg>
        </div>
      </div>
      <div
        v-if="getBeFilter().promo_code != ''"
        class="w-100 pt-4 mt-4 border-top">
        <div v-if="detail.is_load" class="w-100 text-center">
          <loader />
        </div>
        <template v-else>
          <div v-if="detail.error != ''" class="w-100">
            <ErrorMessage :message="detail.error" />
          </div>
          <div
            class="py-3 px-2 mb-2 border radius-0 d-block position-relative"
            style="
              background-color: rgb(243, 255, 244);
              border-color: rgb(193, 254, 184) !important;
            ">
            <div class="row no-gutters">
              <div
                @click="toggleDetail(detail.data)"
                class="col-1 align-self-center cursor-pointer">
                <div
                  class="bg-green p-2 rounded-100 d-table mx-auto"
                  style="line-height: 0 !important">
                  <!-- <img src="../../../../assets/img/icon/correct-white.png" width="15" class="position-relative"> -->
                  <i class="simple-icon-tag text-22 text-white"></i>
                </div>
              </div>
              <div
                @click="toggleDetail(detail.data)"
                class="col-9 align-self-center cursor-pointer">
                <div class="mx-2">
                  <!-- <p class="mb-0 body-3-3-1 text-10" v-if="is_match_product">{{$t('hotel.concierge.promotion.promotion-applied')}}</p> -->
                  <p class="mb-0 body-3-3-1 text-10">
                    {{ $t('hotel.concierge.promotion.promotion-applied') }}
                  </p>
                  <p class="mb-0 text-green body-1-4">{{ detail.data.name }}</p>
                  <p class="mb-0 body-2-2">{{ detail.data.description }}</p>
                </div>
              </div>
              <div class="col-2 align-self-center">
                <button
                  @click="removeCurrentPromoCode"
                  :disabled="disabled_all_btn"
                  :class="{ 'button-disabled': disabled_all_btn }"
                  class="button-secondary button-sm w-100">
                  Remove
                </button>
              </div>
            </div>
          </div>
          <p
            v-if="detail.error_remove != ''"
            class="mb-0 body-1-4 text-danger w-100 text-center">
            Failed to remove promo code : {{ detail.error_remove }}. Please try
            again
          </p>
        </template>
      </div>
      <b-collapse
        id="detail_pc"
        class="mt-4 border-top pt-4"
        v-model="show_collapse">
        <div class="row mb-4">
          <div class="col-12 mb-2">
            <p class="mb-0 body-1-4">Promo code for room only</p>
          </div>
          <div class="col-9">
            <input
              type="text"
              class="form-control body-2-2 mb-0 font-bold text-18"
              placeholder="Type promo code here"
              style="height: 47px"
              v-model="manual.input"
              @blur="promoCodeToUpperCase"
              @keyup.enter="searchPromo" />
            <p
              class="mb-3 body-3-3-1 text-danger"
              v-if="manual.input_error != ''">
              {{ manual.input_error }}
            </p>
          </div>
          <div class="col-3">
            <button
              @click="searchPromo"
              :disabled="manual.push_load_input"
              :class="{ 'button-disabled': manual.push_load_input }"
              type="button"
              class="button-primary w-100">
              <pulse-loader
                :loading="manual.push_load_input"
                color="#fff"
                v-if="manual.push_load_input">
              </pulse-loader>
              <template v-else>
                {{ $t('hotel.search') }}
              </template>
            </button>
          </div>
        </div>
        <div class="row mb-4" v-if="Object.keys(manual.data).length > 0">
          <div class="col-12">
            <p class="mb-3 body-1-4">Promo code found</p>
          </div>
          <div class="col-6 mb-3">
            <div
              class="w-100 border-form rounded-6"
               :class="manual.error ? 'px-3 pt-3 overflow-hidden' : 'p-3'"
              style="height: 100% !important">
              <div class="row">
                <div
                  class="col-8 align-self-center cursor-pointer"
                  @click="toggleDetail(manual.data, manual.error, manual.isValid)">
                  <p class="mb-0 body-1-4">{{ manual.data.name }}</p>
                  <p
                    class="mb-0 body-3-3-1 text-orange"
                    v-if="
                      avlbUseLeft(manual.data.max_use, manual.data.used) < 4
                    ">
                    {{
                      avlbUseLeft(manual.data.max_use, manual.data.used)
                    }}
                    voucher left. Grab it fast!
                  </p>
                  <p class="mb-0 body-2-2 text-truncate-2">
                    {{ manual.data.description }}
                  </p>
                </div>
                <div class="col-4 align-self-center">
                  <button
                    v-if="
                      !checkIfPromoCodeIsSame(
                        manual.data.promo_code,
                        getBeFilter().promo_code
                      )
                    "
                    @click="applyPromoCode('search')"
                    :disabled="disabled_all_btn || !manual.isValid"
                    :class="{ 'button-disabled': disabled_all_btn || !manual.isValid }"
                    class="button-primary button-sm w-100">
                    <pulse-loader
                      :loading="manual.push_apply"
                      color="#fff"
                      v-if="manual.push_apply"></pulse-loader>
                    <template v-else>Apply</template>
                  </button>
                  <button
                    v-else
                    @click="removeCurrentPromoCode('search')"
                    :disabled="disabled_all_btn"
                    :class="{ 'button-disabled': disabled_all_btn }"
                    class="button-secondary button-sm w-100">
                    <pulse-loader
                      :loading="manual.push_apply"
                      color="#fff"
                      v-if="manual.push_apply"></pulse-loader>
                    <template v-else>Cancel</template>
                  </button>
                </div>
                <div
                  class="col-12 text-center py-2 mt-3 border-t-form bg-light-desktop radius-12-b"
                  v-if="manual.error != ''">
                  <p class="mb-0 body-3-1 text-danger">
                    {{ manual.error }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row border-top-dashed py-3">
          <div v-if="list.is_load" class="col-12">
            <loader />
          </div>
          <template v-else>
            <div v-if="list.error != ''" class="col-12">
              <ErrorMessage :message="list.error" />
            </div>
            <template v-else>
              <div class="col-12" v-if="list.data.length > 0">
                <p class="mb-3 body-1-4">Other promotions available</p>
              </div>
              <div class="col-6 mb-3" v-for="(promo, index) in list.data">
                <div
                  class="w-100 border-form radius-12"
                  style="height: 100% !important">
                  <div
                    class="w-100 radius-12-t promo-mobile no-ws p-2"
                    v-if="promo.data.is_from_membership">
                    <img
                      src="../../../../assets/img/icon/menu-navbar/Promo.svg"
                      width="20"
                      class="d-inline-block align-middle mr-2" />
                    <p class="mb-0 d-inline-block align-middle body-3-1">
                      Special discount for membership
                    </p>
                  </div>
                  <div :class="promo.error ? 'px-3 pt-3 overflow-hidden' : 'p-3'">
                    <div class="row">
                      <div
                        class="col-8 align-self-center cursor-pointer"
                        @click="toggleDetail(promo.data, promo.error, promo.isValid)">
                        <p class="mb-0 body-1-4">{{ promo.data.name }}</p>
                        <p
                          class="mb-0 body-3-3-1 text-orange"
                          v-if="
                            avlbUseLeft(promo.data.max_use, promo.data.used) < 4
                          ">
                          {{
                            avlbUseLeft(promo.data.max_use, promo.data.used)
                          }}
                          voucher left. Grab it fast!
                        </p>
                        <p class="mb-0 body-2-2 text-truncate-2">
                          {{ promo.data.description }}
                        </p>
                      </div>
                      <div class="col-4 align-self-center">
                        <button
                          v-if="
                            !checkIfPromoCodeIsSame(
                              promo.data.promo_code,
                              getBeFilter().promo_code
                            )
                          "
                          @click="applyPromoCode('list', index)"
                          :disabled="disabled_all_btn || !promo.isValid"
                          :class="{ 'button-disabled': disabled_all_btn || !promo.isValid }"
                          class="button-primary button-sm w-100">
                          <pulse-loader
                            :loading="promo.push_load"
                            color="#fff"
                            v-if="promo.push_load"></pulse-loader>
                          <template v-else>Apply</template>
                        </button>
                        <button
                          v-else
                          @click="removeCurrentPromoCode('list', index)"
                          :disabled="disabled_all_btn"
                          :class="{ 'button-disabled': disabled_all_btn }"
                          class="button-secondary button-sm w-100">
                          <pulse-loader
                            :loading="promo.push_load"
                            color="#fff"
                            v-if="promo.push_load"></pulse-loader>
                          <template v-else>Cancel</template>
                        </button>
                      </div>
                      <div
                        class="col-12 text-center py-2 mt-3 border-t-form bg-light-desktop radius-12-b"
                        v-if="promo.error != ''">
                        <p class="mb-0 body-3-1 text-danger">
                          {{ promo.error }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
        <div class="w-100 border-top-dashed py-3">
          <PromoCode :isCombine="true" />
        </div>
      </b-collapse>
    </div>

    <!-- DETAIL -->
    <template v-if="popup.data != null">
      <PopUpBackground :data="true"></PopUpBackground>
      <div class="position-relative" style="z-index: 1046">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-table w-100 nav-bottom" style="top: 40px">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div
                  class="col-6 col-md-6 col-lg-5 col-xl-4 rounded-4 position-relative">
                  <div class="rounded-4 bg-white" style="height: 90vh">
                    <div class="">
                      <div class="row no-gutters">
                        <div class="col-12 position-relative">
                          <div
                            class="w-100 rounded-4"
                            style="overflow-y: auto; height: 90vh">
                            <img
                              src="../../../../assets/img/icon/cancel.png"
                              class="d-inline-block p-2 bg-back mt-3 mx-4 cursor-pointer position-absolute rounded-3"
                              width="33"
                              style="z-index: 1038; right: 0"
                              @click="toggleDetail()" />
                            <div class="pb-4">
                              <div class="container px-4 py-3">
                                <p class="mb-0 body-1-4 text-20">
                                  {{ popup.data.name }}
                                </p>
                                <p
                                  class="mb-3 body-3-3-1 text-orange"
                                  v-if="
                                    avlbUseLeft(
                                      popup.data.max_use,
                                      popup.data.used
                                    ) < 4
                                  ">
                                  {{
                                    avlbUseLeft(
                                      popup.data.max_use,
                                      popup.data.used
                                    )
                                  }}
                                  voucher left. Grab it fast!
                                </p>
                                <div class="mb-3 w-100">
                                  <p class="mb-0 body-2 font-regular">
                                    Promo Code:
                                  </p>
                                  <p class="mb-0 body-2-2 font-bold text-14">
                                    {{ popup.data.promo_code }}
                                  </p>
                                </div>
                                <div class="mb-3 w-100">
                                  <p class="mb-0 body-2 font-regular">
                                    Apply on:
                                  </p>
                                  <p class="mb-0 body-2-2 font-bold text-14">
                                    {{ applyOnParser(popup.data.apply_on) }}
                                  </p>
                                </div>
                                <div class="my-3 pb-4">
                                  <p class="mb-0 body-3-3 text-16 font-bold">
                                    {{ $t('general.description') }}
                                  </p>
                                  <p class="body-3-3 text-14 font-regular">
                                    {{ popup.data.description }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="position-absolute w-100 mb-3"
                            style="bottom: -16px">
                            <div class="w-100 px-0">
                              <div
                                class="row justify-content-center no-gutters">
                                <div class="col-12 position-relative">
                                  <div class="">
                                    <div class="w-100">
                                      <div
                                        class="container px-4 pt-2 pb-3 bg-white box-shadow-footer">
                                        <p
                                          class="mb-2 body-3-1 w-100 text-center text-danger"
                                          v-if="popup.error != ''">
                                          {{ popup.error }}
                                        </p>
                                        <button
                                          v-if="
                                            !checkIfPromoCodeIsSame(
                                              popup.data.promo_code,
                                              getBeFilter().promo_code
                                            )
                                          "
                                          @click="applyPromoCode('popup')"
                                          :disabled="disabled_all_btn || !popup.isValid"
                                          :class="{
                                            'button-disabled': disabled_all_btn || !popup.isValid,
                                          }"
                                          class="button-primary button-sm w-100">
                                          <pulse-loader
                                            :loading="popup.push_load"
                                            color="#fff"
                                            v-if="
                                              popup.push_load
                                            "></pulse-loader>
                                          <template v-else>Apply</template>
                                        </button>
                                        <button
                                          v-else
                                          @click="
                                            removeCurrentPromoCode('popup')
                                          "
                                          :disabled="disabled_all_btn"
                                          :class="{
                                            'button-disabled': disabled_all_btn,
                                          }"
                                          class="button-secondary button-sm w-100">
                                          <pulse-loader
                                            :loading="popup.push_load"
                                            color="#fff"
                                            v-if="
                                              popup.push_load
                                            "></pulse-loader>
                                          <template v-else>Cancel</template>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { get } from '@/services/index.js';
import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
import moment from 'moment';
import PromoCode from '../additionalService/PromoCode.vue';

export default {
  components: {
    PopUpBackground,
    PromoCode
  },
  data() {
    return {
      manual: {
        input: '',
        push_load_input: false,
        input_error: '',
        data: {},
        push_apply: false,
        error: '',
        isValid: true
      },
      room_list: [],
      disabled_all_btn: false,
      list: {
        data: {},
        is_load: false,
        error: '',
      },
      show_collapse: false,
      detail: {
        data: {},
        is_load: false,
        error: '',
        error_remove: '',
      },
      popup: {
        data: null,
        push_load: false,
        error: '',
        isValid: true
      },
    };
  },
  computed: {
    disabled() {
      let return_data = false;
      if (this.getMembershipRewardApplied().id) {
        return_data = true;
      }
      return return_data;
    },
  },
  mounted() {
    this.firstLoadData();
  },
  methods: {
    ...mapGetters([
      'getMerchant',
      'getBeFilter',
      'getCurrentLanguage',
      'getBeCartRoom',
      'getMembershipRewardApplied',
    ]),
    ...mapMutations(['setBeFilter', 'beReplaceDataRoomRate']),
    promoCodeToUpperCase() {
      let copy = this.manual.input.toUpperCase();
      this.manual.input = copy;
    },
    checkIfPromoCodeIsSame(pc_1, pc_2) {
      let data_1 = pc_1.toLowerCase();
      let data_2 = pc_2.toLowerCase();
      return data_1 == data_2 ? true : false;
    },
    avlbUseLeft(max, used) {
      return max - used;
    },
    applyOnParser(data) {
      if (data == 'EVERY_NIGHT') {
        return 'Every Night';
      } else if (data == 'FIRST_NIGHT') {
        return 'First Night';
      } else if (data == 'LAST_NIGHT') {
        return 'Last Night';
      } else {
        return data;
      }
    },
    firstLoadData() {
      this.getPromoCodeAvlb();
    },
    toggleDetail(data = null, error = "", isValid = true) {
      if (!this.popup.push_load) {
        this.popup.data = data;
        this.popup.push_load = false;
        this.popup.error = error;
        this.popup.isValid = isValid;
      }
    },
    changeVuexRoomData(type = 'remove', promo) {
      return new Promise((done) => {
        for (let i = 0; i < this.getBeCartRoom().length; i++) {
          let room_rate = this.getBeCartRoom()[i].room_rate;
          let rt_record = this.room_list.findIndex(
            (rt) => rt.id == room_rate.room_type.id
          );
          if (rt_record != -1) {
            let rr_record = this.room_list[rt_record].room_rate.findIndex(
              (rr) => rr.id_ori == room_rate.id_ori
            );

            if (rr_record != -1) {
              this.beReplaceDataRoomRate(
                this.room_list[rt_record].room_rate[rr_record]
              );
            }
          }
          if (i + 1 == this.getBeCartRoom().length) {
            let params = {
              date: {
                check_in: this.getBeFilter().date.check_in,
                check_out: this.getBeFilter().date.check_out,
              },
              guest: {
                adult: this.getBeFilter().guest.adult,
                child: this.getBeFilter().guest.child,
                infant: this.getBeFilter().guest.infant,
              },
              promo_code: type == 'replace' ? promo.promo_code : '',
            };
            this.setBeFilter(params);
            if (type == 'remove') {
              this.detail.data = {};
            } else {
              this.detail.data = promo;
            }
            done(true);
          }
        }
      });
    },
    checkPromoCode(promo_id) {
      return new Promise((done) => {
        let total_promo = 0;
        // looping room type
        if (this.room_list.length == 0) {
          done(total_promo);
        } else {
          for (let i_r = 0; i_r < this.room_list.length; i_r++) {
            // looping room rate
            for (
              let i_rr = 0;
              i_rr < this.room_list[i_r].room_rate.length;
              i_rr++
            ) {
              let room_rate = this.room_list[i_r].room_rate[i_rr];
              // looping room rate date
              for (let i_rrd = 0; i_rrd < room_rate.dates.length; i_rrd++) {
                let promo_date = room_rate.dates[i_rrd].promo_combine;

                if (promo_date != null) {
                  let matched_promo = promo_date.promotion_list.filter(
                    (promo) =>
                      promo.promotion_type == 'PROMO_CODE' && promo.is_apply
                  );

                  if (matched_promo.length > 0) {
                    // check data to vuex
                    let v_rr = this.getBeCartRoom().findIndex(
                      (rr) => rr.room_rate.id_ori == room_rate.id_ori
                    );
                    if (v_rr != -1) {
                      let v_rrd = this.getBeCartRoom()[
                        v_rr
                      ].room_rate.dates.findIndex(
                        (rrd) => rrd.date == room_rate.dates[i_rrd].date
                      );
                      if (v_rrd != -1) {
                        let check_promo_matched = matched_promo.some(
                          (x) => x.id == promo_id
                        );
                        if (check_promo_matched) {
                          total_promo++;
                        }
                      }
                    }
                  }
                }
                if (
                  total_promo > 0 ||
                  (i_r + 1 == this.room_list.length &&
                    i_rr + 1 == this.room_list[i_r].room_rate.length &&
                    i_rrd + 1 ==
                      this.room_list[i_r].room_rate[i_rr].dates.length)
                ) {
                  done(total_promo);
                }
              }
            }
          }
        }
      });
    },
    async applyPromoCode(type, index) {
      this.disabled_all_btn = true;
      this.list.data = this.list.data.map((x) => {
        x.error = '';
        return x;
      });
      if (type == 'list') {
        this.list.data[index].push_load = true;
      } else if (type == 'search') {
        this.manual.push_apply = true;
        this.manual.error = '';
      } else if (type == 'popup') {
        this.popup.push_load = true;
        this.popup.error = '';
      }
      let promotion =
        type == 'list'
          ? this.list.data[index].data
          : type == 'search'
          ? this.manual.data
          : type == 'popup'
          ? this.popup.data
          : this.detail.data;

      let room_response = await this.getRoomList(promotion.promo_code).then(
        (response) => {
          return response;
        }
      );
      if (room_response == true) {
        const total_promo = await this.checkPromoCode(promotion.id).then(
          (res) => {
            return res;
          }
        );
        if (total_promo > 0) {
          this.changeVuexRoomData('replace', promotion).then(() => {
            this.disabled_all_btn = false;
            if (type == 'list') {
              this.list.data[index].push_load = false;
            } else if (type == 'search') {
              this.manual.push_apply = false;
            } else {
              this.popup.push_load = false;
              this.toggleDetail();
            }
          });
        } else {
          this.disabled_all_btn = false;
          let error =
            'Sorry, this promo has no effect on the room you have selected';
          if (type == 'list') {
            this.list.data[index].push_load = false;
            this.list.data[index].error = error;
          } else if (type == 'search') {
            this.manual.push_apply = false;
            this.manual.error = error;
          } else if (type == 'popup') {
            this.popup.push_load = false;
            this.popup.error = error;
          } else {
            this.detail.error = error;
            this.emitToShowErrorApllied(true, promotion);
          }
        }
      } else {
        this.disabled_all_btn = false;
        let error = 'Error while trying to apply promo code. Please try again';
        if (type == 'list') {
          this.list.data[index].push_load = false;
          this.list.data[index].error = error;
        } else if (type == 'search') {
          this.manual.push_apply = false;
          this.manual.error = error;
        } else if (type == 'popup') {
          this.popup.push_load = false;
          this.popup.error = error;
        } else {
          this.detail.error = error;
          this.emitToShowErrorApllied(true, promotion);
        }
      }
    },
    emitToShowErrorApllied(show = false, promotion) {
      let data_res = {
        show: show,
        promo: show ? promotion : {},
      };
      this.$emit('applyPromoCode', data_res);
    },
    removeCurrentPromoCode(type = 'selected', index) {
      this.disabled_all_btn = true;
      if (type == 'list') {
        this.list.data = this.list.data.map((x) => {
          x.error = '';
          return x;
        });
        this.list.data[index].push_load = true;
      } else if (type == 'selected') {
        this.detail.is_load = true;
        this.detail.error_remove = '';
      } else if (type == 'search') {
        this.manual.push_apply = true;
        this.manual.error = '';
      } else {
        this.popup.push_load = true;
        this.popup.error = '';
      }
      this.getRoomList().then((response) => {
        if (response == true) {
          this.changeVuexRoomData().then(() => {
            this.disabled_all_btn = false;
            if (type == 'list') {
              this.list.data[index].push_load = false;
            } else if (type == 'selected') {
              this.detail.is_load = false;
            } else if (type == 'search') {
              this.manual.push_apply = false;
            } else if (type == 'popup') {
              this.popup.push_load = false;
              this.toggleDetail();
            }
            this.emitToShowErrorApllied();
          });
        } else {
          this.disabled_all_btn = false;
          if (type == 'list') {
            this.list.data[index].push_load = false;
            this.list.data[index].error = response;
          } else if (type == 'selected') {
            this.detail.is_load = false;
            this.detail.error_remove = response;
          } else if (type == 'search') {
            this.manual.push_apply = false;
            this.manual.error = response;
          } else {
            this.popup.push_load = false;
            this.popup.error = response;
          }
        }
      });
    },
    searchPromo() {
      this.manual.push_load_input = true;
      this.manual.input_error = '';
      this.getRoomList(this.manual.input).then((rl_response) => {
        if (rl_response == true) {
          this.getPromoCodeDetail(this.manual.input).then((pcd_response) => {
            if (pcd_response.success) {
              this.manual.data = pcd_response.data;

              const { check_in, check_out } = this.getBeFilter().date
              const totalNight = this.$countDays(check_in, check_out)
              const isMinNightValid = totalNight >= pcd_response.data.min_night;
              this.manual.isValid = isMinNightValid;
              this.manual.error = !isMinNightValid ? `Minimum stay ${pcd_response.data.min_night} nights required for this promo` : ''
            } else {
              this.manual.input_error = pcd_response.message;
            }
            this.manual.push_load_input = false;
          });
        } else {
          this.manual.input_error = rl_response;
          this.manual.push_load_input = false;
        }
      });
    },
    getPromoCodeApplied() {
      this.detail = {
        data: {},
        is_load: false,
        error: '',
        error_remove: '',
      };
      this.getPromoCodeDetail(this.getBeFilter().promo_code).then(
        (response) => {
          if (response.success) {
            this.detail.data = response.data;
            this.applyPromoCode('selected');
          } else {
            this.detail.error = response.message;
          }
          this.detail.is_load = false;
        }
      );
    },
    getRoomList(promo_code = '') {
      return new Promise((done) => {
        let params = {
          merchant_id: this.getMerchant().id,
          check_in_date: moment(this.getBeFilter().date.check_in).format(
            'YYYY-MM-DD'
          ),
          check_out_date: moment(this.getBeFilter().date.check_out).format(
            'YYYY-MM-DD'
          ),
          adult: this.getBeFilter().guest.adult,
          child: this.getBeFilter().guest.child,
          infant: this.getBeFilter().guest.infant,
          sort_by: 'room_type',
          price_min: '',
          price_max: '',
          language_code: this.getCurrentLanguage(),
          device: 'DESKTOP',
          use_promotion_combine: true,
        };
        if (promo_code != '') {
          params.promo_code = promo_code;
        }

        get('CORE_HOTEL', 'search-room', params).then((response) => {
          let res = response.data;
          if (res.success) {
            this.room_list = res.data.map((x) => {
              x.room_rate = x.room_rate.map((y, y_i) => {
                let id_ori = y.id;
                y.id_ori = id_ori;
                y.id = `${id_ori}_${y_i}`;
                return y;
              });
              return x;
            });
            done(true);
          } else {
            done(res.message);
          }
        });
      });
    },
    getPromoCodeAvlb() {
      this.list.is_load = true;
      this.list.error = '';
      get('CORE_HOTEL', 'promocode-option', {
        merchant_id: this.getMerchant().id,
        check_in_date: moment(this.getBeFilter().date.check_in).format(
          'YYYY-MM-DD'
        ),
        check_out_date: moment(this.getBeFilter().date.check_out).format(
          'YYYY-MM-DD'
        ),
      }).then((response) => {
        let res = response.data;
        if (res.success) {
          if (res.data.length > 0) {
            this.show_collapse = true;
          }
          this.list.data = [];
          this.list.data = this.validatePromoCode(res.data);
          if (this.getBeFilter().promo_code != '') {
            this.getPromoCodeApplied();
          }
        } else {
          this.list.error = res.message;
        }
        this.list.is_load = false;
      });
    },
    getPromoCodeDetail(pc) {
      return new Promise((done) => {
        get('CORE_HOTEL', 'promocode-detail', {
          merchant_id: this.getMerchant().id,
          check_in_date: moment(this.getBeFilter().date.check_in).format(
            'YYYY-MM-DD'
          ),
          check_out_date: moment(this.getBeFilter().date.check_out).format(
            'YYYY-MM-DD'
          ),
          promo_code: pc,
        }).then((response) => {
          done(response.data);
        });
      });
    },
    toggleCollapse() {
      if (!this.disabled) {
        this.show_collapse = !this.show_collapse;
      }
    },
    validatePromoCode(promoList){
      const { check_in, check_out } = this.getBeFilter().date
      const totalNight = this.$countDays(check_in, check_out)
      return promoList.map(promo => {
        const isMinNightValid = totalNight >= promo.min_night;
        return {
          ...promo,
          data: promo,
          push_load: false,
          error: !isMinNightValid ? `Minimum stay ${promo.min_night} nights required for this promo` : '',
          isValid: isMinNightValid
        };
      })
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/desktop/promoCode.vue